import { useState, useEffect, useRef } from "react";
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import axios from "axios";
import ThemeMaker from "../../components/thememaker";
import { tokenDecode } from "../../utils/helper";
import { toast } from "react-toastify";
import { config } from "../../utils/config";
import btnstyle from "../../components/Buttons/Buttons.module.css"
import styles from "../transaction/transaction.module.css"
import Brandlist from "../../components/Brandlist Template/Brandlist";
import { v4 as uuidv4 } from 'uuid';
import { Modal as AntModal } from "antd";
import { Paginated } from "../../components/Paginated";
import "../../index.css";

const { apiEndpoint, awsKeyId, awsSecretKey, awsRegion, awsBucket, baseNodeapiUrl } = config;

export const getBrandImageUrl = (row) => {
    if (!row) return null;
    let val = row.image ?? row.images ?? row.brand_image ?? row.brand_images ??
        row.logo ?? row.brand_logo ?? row.img ?? row.url ?? row.image_url ??
        row.Image ?? row.Images ?? row.photo ?? row.icon ?? row.media ?? row.file;

    if (!val) return null;

    if (Array.isArray(val)) {
        if (val.length === 0) return null;
        val = val[0];
    }

    if (typeof val === 'object' && val !== null) {
        val = val.url || val.src || val.path || val.link || val.location || val.image || val.images || Object.values(val)[0];
    }

    if (typeof val === 'string') {
        val = val.trim();
        if (!val || val === 'null' || val === 'undefined' || val === '""' || val === '[]' || val === '{}') {
            return null;
        }

        if ((val.startsWith('[') && val.endsWith(']')) || (val.startsWith('{') && val.endsWith('}'))) {
            try {
                const parsed = JSON.parse(val);
                if (Array.isArray(parsed) && parsed.length > 0) {
                    val = typeof parsed[0] === 'string' ? parsed[0] : (parsed[0]?.url || parsed[0]?.src || '');
                } else if (typeof parsed === 'object' && parsed !== null) {
                    val = parsed.url || parsed.src || parsed.link || parsed.image || '';
                }
            } catch (err) {
                val = val.replace(/^[\["']+|[\]"']+$/g, '').trim();
            }
        }

        if (typeof val === 'string' && val.includes(',')) {
            val = val.split(',')[0].trim();
        }

        if (typeof val === 'string') {
            val = val.replace(/^["']+|["']+$/g, '').trim();
        }

        if (typeof val === 'string' && val.length > 0 && val !== 'null' && val !== 'undefined') {
            return val;
        }
    }

    return null;
};

const Brand = () => {
    const decoded = tokenDecode();
    const { data } = decoded;
    const { permission: { category } } = data;
    const [listing, setListing] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [listingLoading, setListingLoading] = useState(true);
    const [taxData, setTaxData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [isSearching, setIsSearching] = useState(false);
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);
    const [brand, setBrand] = useState({
        brand_name: '',
        status: true,
        images: ''
    });
    const taxD = {
        brand_name: false,
        images: false
    }
    const [BrandErrorData, setBrandErrorData] = useState(taxD);
    const errorHandler = (e) => {
        const { name, value } = e.target;
        if (name === "brand_name") {
            if (!value || (typeof value === "string" && !value.trim())) {
                setBrandErrorData((prev) => ({ ...prev, brand_name: true }));
            } else if (!/^[a-zA-Z0-9\s.'-]+$/.test(value.trim())) {
                setBrandErrorData((prev) => ({ ...prev, brand_name: "invalid" }));
            } else {
                setBrandErrorData((prev) => ({ ...prev, brand_name: false }));
            }
        } else if (name === "images") {
            if (!brand.images) {
                setBrandErrorData((prev) => ({ ...prev, images: true }));
            } else {
                setBrandErrorData((prev) => ({ ...prev, images: false }));
            }
        } else {
            if (value) {
                setBrandErrorData((prev) => ({ ...prev, [name]: false }));
            } else {
                setBrandErrorData((prev) => ({ ...prev, [name]: true }));
            }
        }
    };

    const createBrandHandler = async () => {
        const brandNameRegex = /^[a-zA-Z0-9\s.'-]+$/;
        const trimmedName = (brand?.brand_name || "").trim();

        let hasError = false;
        let errors = { ...BrandErrorData };

        if (!trimmedName) {
            errors.brand_name = true;
            hasError = true;
        } else if (!brandNameRegex.test(trimmedName)) {
            errors.brand_name = "invalid";
            hasError = true;
        } else {
            errors.brand_name = false;
        }

        if (!brand?.images) {
            errors.images = true;
            hasError = true;
        } else {
            errors.images = false;
        }

        setBrandErrorData(errors);

        if (hasError) {
            if (errors.brand_name === "invalid") {
                toast.error("Special characters are not allowed in brand name !");
            } else if (!trimmedName && !brand?.images) {
                toast.error("Please fill all required fields !");
            } else if (!trimmedName) {
                toast.error("Please enter Brand Name !");
            } else if (!brand?.images) {
                toast.error("Please upload Brand Image !");
            }
            return;
        }

        try {
            setLoading(true);
            const { data } = await axios({
                url: `${apiEndpoint}/snp/brand/create`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
                data: {
                    "brand_name": trimmedName,
                    "status": brand.status,
                    "images": brand.images,
                    "image": brand.images,
                    "brand_image": brand.images
                }
            });
            setLoading(false);
            if (data?.status === true || data?.status === 200) {
                toast.success(data?.message || "New Brand created !");
                setBrand({
                    brand_name: '',
                    status: true,
                    images: ''
                });
                setBrandErrorData({ brand_name: false, images: false });
                brandListHandler();
            } else {
                toast.error(data?.message || "Error creating brand!");
            }
        } catch (error) {
            setLoading(false);
            const errMsg = error?.response?.data?.message || error?.response?.data?.error || error?.message || "Error creating brand!";
            toast.error(errMsg);
        }
    };

    const brandListHandler = async () => {
        try {
            setListing(false);
            setListingLoading(true);
            const { data } = await axios({
                url: `${apiEndpoint}/snp/brand/get-all`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                }
            });
            // console.log("brand listing data --->", data);
            setListingLoading(false);
            if (data?.status === true || data?.status === 200 || data?.brands || data?.data) {
                const brandsList = data.brands || data.data || [];
                setTaxData(brandsList);
            }
        } catch (error) {
            console.log("error", error);
            setListingLoading(false);
        }
    };

    const handleBrandSearch = async (queryText) => {
        const term = queryText !== undefined ? queryText : searchQuery;
        if (!term || !term.trim()) {
            brandListHandler();
            return;
        }
        try {
            setIsSearching(true);
            setListingLoading(true);
            const { data } = await axios({
                url: `${apiEndpoint}/snp/brand/search`,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`,
                },
                data: {
                    name: term.trim()
                }
            });
            setIsSearching(false);
            setListingLoading(false);
            if (data && (data.status === true || data.status === 200)) {
                const results = data.brands || data.data || (Array.isArray(data) ? data : []);
                setTaxData(Array.isArray(results) ? results : []);
            } else {
                setTaxData([]);
            }
        } catch (error) {
            console.log("Brand search error:", error);
            setIsSearching(false);
            setListingLoading(false);
            setTaxData([]);
        }
    };

    useEffect(() => {
        if (!searchQuery || !searchQuery.trim()) return;
        const timer = setTimeout(() => {
            handleBrandSearch(searchQuery);
        }, 400);

        return () => clearTimeout(timer);
    }, [searchQuery]);

    const handleClearSearch = () => {
        setSearchQuery("");
        brandListHandler();
    };
    const setCrete = () => {
        setListing(true);
        setIsUpdate(false);
        setBrand({
            brand_name: '',
            status: true,
            images: ""
        })
    }
    const editRedirect = async (id) => {
        setListing(true);
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/snp/brand/get/${id}`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
            });
            if (data?.status === true || data?.status === 200) {
                const brandData = data?.brands?.[0] || data?.brand || data?.data || {};
                setBrand({
                    brand_name: brandData?.brand_name || '',
                    status: brandData?.status ?? true,
                    images: getBrandImageUrl(brandData) || brandData?.image || brandData?.images || '',
                    id: brandData?.id || id
                });
            }
        } catch (error) {
            console.log("Error fetching brand:", error);
        }
        setIsUpdate(true);
    };

    const updateTax = async () => {
        const brandNameRegex = /^[a-zA-Z0-9\s.'-]+$/;
        const trimmedName = (brand?.brand_name || "").trim();

        let hasError = false;
        let errors = { ...BrandErrorData };

        if (!trimmedName) {
            errors.brand_name = true;
            hasError = true;
        } else if (!brandNameRegex.test(trimmedName)) {
            errors.brand_name = "invalid";
            hasError = true;
        } else {
            errors.brand_name = false;
        }

        if (!brand?.images) {
            errors.images = true;
            hasError = true;
        } else {
            errors.images = false;
        }

        setBrandErrorData(errors);

        if (hasError) {
            if (errors.brand_name === "invalid") {
                toast.error("Special characters are not allowed in brand name !");
            } else if (!trimmedName && !brand?.images) {
                toast.error("Please fill all required fields !");
            } else if (!trimmedName) {
                toast.error("Please enter Brand Name !");
            } else if (!brand?.images) {
                toast.error("Please upload Brand Image !");
            }
            return;
        }

        try {
            setLoading(true);
            const { data } = await axios({
                url: `${apiEndpoint}/snp/brand/update/${brand.id}`,
                method: "PUT",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
                data: {
                    "brand_name": trimmedName,
                    "status": brand.status,
                    "image": brand.images,
                    "images": brand.images,
                    "brand_image": brand.images
                }
            });
            setLoading(false);
            if (data?.status === true || data?.status === 200) {
                toast.success(data?.message || "Brand Updated !");
                setBrand({
                    brand_name: '',
                    status: true,
                    images: ''
                });
                setBrandErrorData({ brand_name: false, images: false });
                setIsUpdate(false);
                brandListHandler();
            } else {
                toast.error(data?.message || "Error updating brand!");
            }
        } catch (error) {
            setLoading(false);
            const errMsg = error?.response?.data?.message || error?.response?.data?.error || error?.message || "Error updating brand!";
            toast.error(errMsg);
        }
    };

    const deleteTax = async (id) => {
        if (!window.confirm("Are you sure you want to delete this brand?")) {
            return;
        }
        try {
            setLoading(true);
            const { data } = await axios({
                url: `${apiEndpoint}/snp/brand/delete/${id}`,
                method: "DELETE",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
                },
            });
            if (data?.status === true || data?.status === 200) {
                toast.success(data?.message || "Brand Deleted !");
                brandListHandler();
            } else {
                toast.error(data?.message || "Error deleting brand!");
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            const errMsg = error?.response?.data?.message || error?.response?.data?.error || error?.message || "Error deleting brand!";
            toast.error(errMsg);
        }
    };


    const productImageHandler = async (e) => {
        const files = e.target.files;


        if (!files || files.length === 0) {
            alert("Please select file(s) first!");
            return;
        }

        const formData = new FormData();

        for (let i = 0; i < files.length; i++) {
            formData.append("files", files[i]); // Use the same key 'files'
        }

        try {
            const { data } = await axios.post(
                `${baseNodeapiUrl}/digidukaan/snp/upload`,
                formData,
                {
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`,
                        // Let browser set Content-Type
                    }
                }
            );

            if (data?.success) {
                toast.success(data.message || "Upload successful!");
                console.log("Uploaded URLs:", data.urls);

                setBrand((prev) => ({ ...prev, [e.target.name]: data.urls[0] }));
                setBrandErrorData((prev) => ({ ...prev, images: false }));

            } else {
                toast.error("Upload failed!");
            }

        } catch (err) {
            console.error("Upload failed:", err);
            alert("Upload failed!");
        }
    };


    const open = () => {
        setIsPreviewOpen(true);
    };


    const COLUMNS = [
        {
            Header: "Serial No.",
            Footer: "Serial No.",
            accessor: (row, count) => <span style={{ fontWeight: 600, color: "#64748B" }}>{count + 1}</span>,
            disableFilters: true,
        },
        {
            Header: "Image",
            Footer: "Image",
            accessor: (row) => {
                const imgUrl = getBrandImageUrl(row);
                return imgUrl ? (
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "44px", height: "44px" }}>
                        <img
                            src={imgUrl}
                            alt={row.brand_name || "Brand"}
                            referrerPolicy="no-referrer"
                            style={{
                                width: "44px",
                                height: "44px",
                                objectFit: "contain",
                                borderRadius: "8px",
                                border: "1px solid #E2E8F0",
                                padding: "3px",
                                backgroundColor: "#FFFFFF",
                                display: "block"
                            }}
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.style.display = "none";
                                if (e.target.nextSibling) {
                                    e.target.nextSibling.style.display = "flex";
                                }
                            }}
                        />
                        <div
                            style={{
                                display: "none",
                                width: "40px",
                                height: "40px",
                                borderRadius: "8px",
                                backgroundColor: "#F1F5F9",
                                color: "#64748B",
                                fontSize: "14px",
                                fontWeight: 700,
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                        >
                            {(row?.brand_name || "B").charAt(0).toUpperCase()}
                        </div>
                    </div>
                ) : (
                    <div
                        style={{
                            display: "flex",
                            width: "40px",
                            height: "40px",
                            borderRadius: "8px",
                            backgroundColor: "#F1F5F9",
                            color: "#64748B",
                            fontSize: "14px",
                            fontWeight: 700,
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        {(row.brand_name || "B").charAt(0).toUpperCase()}
                    </div>
                );
            },
            disableFilters: true,
        },
        {
            Header: "Brand Name",
            Footer: "Brand Name",
            accessor: (row) => {
                const name = (row?.brand_name || "").trim();
                const displayName = name.length > 40 ? `${name.slice(0, 40)}...` : (name || "—");
                return (
                    <span
                        title={name}
                        style={{
                            fontWeight: 600,
                            color: "#0F172A",
                            fontSize: "14px",
                            wordBreak: "break-word",
                            overflowWrap: "anywhere",
                            display: "inline-block",
                            maxWidth: "450px"
                        }}
                    >
                        {displayName}
                    </span>
                );
            },
        },
        {
            Header: "Status",
            Footer: "Status",
            accessor: (row) => {
                const isInactive = row.status === false || row.status === 0 || row.status === "0";
                return (
                    <span
                        style={{
                            borderRadius: "20px",
                            fontSize: "12px",
                            fontWeight: 700,
                            backgroundColor: isInactive ? "#FEF2F2" : "#F0FDF4",
                            color: isInactive ? "#DC2626" : "#16A34A",
                            border: `1px solid ${isInactive ? "#FECACA" : "#BBF7D0"}`,
                            padding: "4px 12px",
                            display: "inline-block"
                        }}
                    >
                        {isInactive ? "Inactive" : "Active"}
                    </span>
                );
            },
        },
        {
            Header: "Action",
            Footer: "Action",
            accessor: (row) => {
                return (
                    <div className="d-flex align-items-center justify-content-center" style={{ gap: "6px" }}>
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => editRedirect(row.id)}
                            style={{ borderRadius: "6px", width: "32px", height: "32px", padding: 0 }}
                            title="Edit Brand"
                        >
                            <i className="fas fa-pen"></i>
                        </button>

                        <button
                            type="button"
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => deleteTax(row.id)}
                            style={{ borderRadius: "6px", width: "32px", height: "32px", padding: 0 }}
                            title="Delete Brand"
                        >
                            <i className="fas fa-trash"></i>
                        </button>
                    </div>
                );
            },
        },
    ];
    useEffect(() => {
        brandListHandler()
    }, [])

    // console.log(listing)
    return (
        <>
            <ThemeMaker>
                <div className="row w-100 m-0 m-1">
                    <div className="col-md-12 ">
                        <div className="card shadow mb-4">
                            <div className="card-header py-3 bg-white" style={{ borderBottom: "1px solid #E2E8F0" }}>
                                <div className="d-flex justify-content-between align-items-center flex-wrap" style={{ gap: "12px" }}>
                                    <div>
                                        <h5 className="m-0 font-weight-bold " style={{ color: "#0F172A", fontSize: "24px" }}>
                                            {listing ? (isUpdate ? "Edit Brand" : "Add New Brand") : "Brand List"}
                                        </h5>
                                        {!listing && (
                                            <span className="text-muted" style={{ fontSize: "12px" }}>
                                                Total: {taxData?.length || 0} brands
                                            </span>
                                        )}
                                    </div>

                                    <div className="d-flex align-items-center flex-wrap" style={{ gap: "10px" }}>
                                        {!listing && (
                                            <div style={{ position: "relative", width: "260px" }}>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Search brand name..."
                                                    value={searchQuery}
                                                    onChange={(e) => {
                                                        const val = e.target.value.trimStart();
                                                        const prevVal = searchQuery;
                                                        setSearchQuery(val);
                                                        if (!val.trim() && prevVal.trim() !== "") {
                                                            brandListHandler();
                                                        }
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            e.preventDefault();
                                                            handleBrandSearch(searchQuery);
                                                        }
                                                    }}
                                                    style={{
                                                        borderRadius: "20px",
                                                        height: "36px",
                                                        fontSize: "13px",
                                                        paddingLeft: "34px",
                                                        paddingRight: searchQuery ? "30px" : "12px",
                                                        borderColor: "#CBD5E1",
                                                        backgroundColor: "#F8FAFC"
                                                    }}
                                                />
                                                <span
                                                    style={{
                                                        position: "absolute",
                                                        left: "12px",
                                                        top: "50%",
                                                        transform: "translateY(-50%)",
                                                        color: "#94A3B8",
                                                        fontSize: "13px",
                                                        pointerEvents: "none"
                                                    }}
                                                >
                                                    {isSearching ? <i className="fas fa-spinner fa-spin text-primary"></i> : <i className="fas fa-search"></i>}
                                                </span>
                                                {searchQuery && (
                                                    <span
                                                        onClick={handleClearSearch}
                                                        style={{
                                                            position: "absolute",
                                                            right: "10px",
                                                            top: "50%",
                                                            transform: "translateY(-50%)",
                                                            color: "#94A3B8",
                                                            fontSize: "13px",
                                                            cursor: "pointer",
                                                            padding: "2px"
                                                        }}
                                                        title="Clear"
                                                    >
                                                        ✕
                                                    </span>
                                                )}
                                            </div>
                                        )}

                                        {listing ? (
                                            <button
                                                onClick={brandListHandler}
                                                style={{ fontSize: "13px", borderRadius: "6px", fontWeight: 600, height: "36px", color: "#0F172A", borderColor: "#0F172A" }}

                                                className="btn btn-primary shadow-sm"
                                            >
                                                ← Brand List
                                            </button>
                                        ) : (
                                            <button
                                                style={{ fontSize: "13px", borderRadius: "6px", fontWeight: 600, height: "36px" }}
                                                onClick={setCrete}
                                                className="btn btn-primary shadow-sm"
                                            >
                                                + Create New Brand
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {
                                !listing ? (
                                    listingLoading ? (
                                        <div className="d-flex flex-column align-items-center justify-content-center py-5" style={{ minHeight: "350px", backgroundColor: "#FFFFFF" }}>
                                            <div className="spinner-border" role="status" style={{ width: "3.2rem", height: "3.2rem", borderWidth: "3.5px", color: "#F97316" }}>
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                            <div className="mt-3 font-weight-bold" style={{ fontSize: "14px", color: "#64748B" }}>Loading Brand List...</div>
                                        </div>
                                    ) : (
                                        <>
                                            <div className={`card-body p-0 ${styles.transactionListing_desktop}`} >
                                                <div style={{ width: "100%", overflowX: "hidden" }}>
                                                    <Paginated data={taxData} columns={COLUMNS} />
                                                </div>
                                            </div>
                                            <div className={`${styles.transactionListing_mobile}`} style={{ padding: "10px", background: 'white' }}>
                                                {taxData.length > 0 ? (
                                                    taxData.map((item, index) => {
                                                        return <Brandlist key={item.id || index} item={item} index={index} editRedirect={editRedirect} deleteTax={deleteTax} />
                                                    })
                                                ) : (
                                                    <div className="text-center p-3 text-muted">No Brands found</div>
                                                )}
                                            </div>
                                        </>
                                    )
                                ) : (
                                    <div className="card-body" style={{ minHeight: "70vh", padding: "28px" }}>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label className="genericlabel" style={{ fontWeight: 600, fontSize: "14px" }}>Brand Name</label>
                                                    <span className="text-danger" > * </span>
                                                    {BrandErrorData?.brand_name === true && (
                                                        <span className="text-danger tiny_size" > This field is required ! </span>
                                                    )}
                                                    {BrandErrorData?.brand_name === "invalid" && (
                                                        <span className="text-danger tiny_size" > Special characters are not allowed in brand name ! </span>
                                                    )}
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="brand_name"
                                                        placeholder="Enter Brand Name.."
                                                        value={brand.brand_name}
                                                        onChange={(e) => setBrand({ ...brand, [e.target.name]: e.target.value })}
                                                        onBlur={(e) => errorHandler(e)}
                                                        style={{ height: "42px", borderRadius: "8px" }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                                        <div>
                                                            <label className="genericlabel" style={{ fontWeight: 600, fontSize: "14px" }}>Brand Image</label>
                                                            <span className="text-danger"> * </span>
                                                        </div>
                                                        {brand.images && (
                                                            <a
                                                                onClick={() => open()}
                                                                style={{
                                                                    fontSize: "12px",
                                                                    color: "#2563EB",
                                                                    cursor: "pointer",
                                                                    textDecoration: "underline",
                                                                    fontWeight: 600
                                                                }}
                                                            >
                                                                <i className="far fa-eye mr-1"></i> View Uploaded Image
                                                            </a>
                                                        )}
                                                    </div>
                                                    {BrandErrorData?.images === true && (
                                                        <span className="text-danger tiny_size"> This field is required ! </span>
                                                    )}
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        onChange={(e) => productImageHandler(e)}
                                                        accept="image/*"
                                                        name="images"
                                                        multiple
                                                        onBlur={(e) => errorHandler(e)}
                                                        id="image"
                                                        style={{ height: "42px", borderRadius: "8px" }}
                                                    />
                                                    {brand.images && (
                                                        <div className="mt-2 d-flex align-items-center" style={{ gap: "10px" }}>
                                                            <img
                                                                src={brand.images}
                                                                alt="Brand Preview"
                                                                onClick={() => open()}
                                                                style={{
                                                                    width: "44px",
                                                                    height: "44px",
                                                                    objectFit: "contain",
                                                                    borderRadius: "6px",
                                                                    border: "1px solid #CBD5E1",
                                                                    padding: "2px",
                                                                    backgroundColor: "#F8FAFC",
                                                                    cursor: "pointer"
                                                                }}
                                                            />
                                                            <span style={{ fontSize: "12px", color: "#16A34A", fontWeight: 600 }}>
                                                                <i className="fas fa-check-circle mr-1"></i> Image Uploaded
                                                            </span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-2">
                                                <div className="form-group d-flex align-items-center" style={{ gap: "10px" }}>
                                                    <input
                                                        type="checkbox"
                                                        id="brand_status"
                                                        checked={brand.status}
                                                        name="status"
                                                        onChange={(e) => setBrand({ ...brand, [e.target.name]: !brand.status })}
                                                        style={{ width: "18px", height: "18px", cursor: "pointer" }}
                                                    />
                                                    <label htmlFor="brand_status" className="m-0 genericlabel" style={{ fontWeight: 600, cursor: "pointer" }}>Active Status</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex mt-4" style={{ gap: "10px" }}>
                                            <button
                                                type="button"
                                                className="btn btn-outline-secondary"
                                                onClick={brandListHandler}
                                                style={{ borderRadius: "8px", fontWeight: 600, padding: "8px 20px" }}
                                            >
                                                Cancel
                                            </button>
                                            {!isUpdate ? (
                                                <button
                                                    onClick={createBrandHandler}
                                                    className="btn btn-primary"
                                                    disabled={loading}
                                                    style={{ borderRadius: "8px", fontWeight: 600, padding: "8px 24px" }}
                                                >
                                                    {loading ? "Creating..." : "Create Brand"}
                                                </button>
                                            ) : (
                                                <button
                                                    onClick={updateTax}
                                                    className="btn btn-primary"
                                                    disabled={loading}
                                                    style={{ borderRadius: "8px", fontWeight: 600, padding: "8px 24px" }}
                                                >
                                                    {loading ? "Updating..." : "Update Brand"}
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>

                {/* Modern Brand Image Preview Modal */}
                <AntModal
                    open={isPreviewOpen}
                    onCancel={() => setIsPreviewOpen(false)}
                    footer={null}
                    centered
                    closable={true}
                    maskClosable={true}
                    width={460}
                    bodyStyle={{ padding: "20px", display: "flex", flexDirection: "column", alignItems: "center" }}
                    style={{ borderRadius: "16px", overflow: "hidden" }}
                >
                    <div style={{ width: "100%", textAlign: "center" }}>
                        <h6 style={{ fontWeight: 700, color: "#0F172A", marginBottom: "14px", fontSize: "15px" }}>
                            Brand Image Preview
                        </h6>
                        <div style={{
                            width: "100%",
                            maxHeight: "360px",
                            borderRadius: "12px",
                            overflow: "hidden",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "#F8FAFC",
                            border: "1px solid #E2E8F0",
                            padding: "12px"
                        }}>
                            <img
                                src={brand.images}
                                alt="Brand Preview"
                                style={{ maxWidth: "100%", maxHeight: "320px", objectFit: "contain", borderRadius: "8px" }}
                            />
                        </div>
                    </div>
                </AntModal>
            </ThemeMaker>
        </>
    )
}

export default Brand;